<template>
  <el-form-item
    :class="`${!valid ? 'is-error' : ''}`"
    style="margin-top: -3px;"
  >
    <el-date-picker
      v-model="expiration"
      :key="dateKey"
      :clearable="false"
      :picker-options="pickerOptions"
      :disabled="disabled"
      popper-class="expiration-date-picker"
      class="expiration-date-picker"
      type="date"
      style="width: 145px; margin-right: 10px; vertical-align: top;"
      format="yyyy. MM. dd."
      value-format="yyyy-MM-dd"
      size="small"
      @change="onExpirationDateChange"
    />
    <div
      v-if="!valid"
      class="el-form-item__error"
      style="padding-top: 0;"
    >
      Kötelező mező
    </div>
  </el-form-item>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default() {
        return false;
      },
      required: false,
    },
    availableExpirationDates: {
      type: Array,
      default() {
        return [];
      },
      required: false,
    },
    valid: {
      type: Boolean,
      default() {
        return true;
      },
      required: false,
    },
    expirationDate: {
      type: String,
      default() {
        return null;
      },
      required: false,
    },
    packType: {
      type: Object,
      default() {
        return {
          count_per_pack: 1,
        };
      },
      required: false,
    },
  },
  data() {
    return {
      dateKey: 0,
      expiration: null,
      pickerOptions: {
        firstDayOfWeek: 1,
      },
    };
  },
  watch: {
    expirationDate(expiration) {
      this.expiration = expiration;
    },
    availableExpirationDates(expirationDates) {
      const options = {
        firstDayOfWeek: 1,
      };
      const shortcuts = expirationDates.map(exp => ({
        text: `${this.$options.filters.date(exp.expiration_date)} (${exp.count} ${this.packType.count_per_pack === 1 ? 'db' : this.packType.pack_type.name })`,
        onClick(picker) {
          picker.$emit('pick', new Date(exp.expiration_date));
        },
      }));
      if (shortcuts && shortcuts.length) {
        options.shortcuts = shortcuts;
      }
      this.pickerOptions = options;
      this.dateKey++;
    },
  },
  mounted() {
    this.expiration = this.expirationDate;
  },
  methods: {
    onExpirationDateChange(expirationDate) {
      this.$emit('change', expirationDate)
    },
  },
};
</script>

<style lang="scss">
  .expiration-date-picker {
    &.el-date-picker.has-sidebar {
      width: 520px;
    }
    .el-picker-panel__sidebar + .el-picker-panel__body {
      margin-left: 200px;
    }
    .el-picker-panel__sidebar {
      width: 200px;
    }
  }
</style>
